import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-number-stepper',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberStepperComponent),
      multi: true,
    },
  ],
})
export class NumberStepperComponent {
  @Input() label = '';
  @Input() unit = '';
  @Input() step = 1;
  @Input() min: number = 30;
  @Input() max: number | null = null;
  @Input() disabled = false;
  @Input() currentValue: number = 30;

  @Output() valueChange = new EventEmitter<number>();

  value = 30;
  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnChanges(): void {

  if (this.currentValue < this.min) {
   this.value = this.min;
  }
  else {
    this.value = this.currentValue
  }

 }

 handleKeyPress(event: any){
  if(event.key === "Enter"){
    const value = event.target.value
    this.commit(parseInt(value))
  }
 }

  writeValue(value: number): void {
    this.value = value ?? 0;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(raw: string): void {
    const parsed = Number(raw);
    this.commit(Number.isNaN(parsed) ? 0 : parsed);
  }

  increment(): void {
    this.commit(this.value + this.step);
  }

  decrement(): void {
    this.commit(this.value - this.step);
  }

  private commit(next: number): void {
    if (this.max !== null) {
      next = Math.min(next, this.max);
    }
    if (this.min !== null) {
      next = Math.max(next, this.min);
    }

    this.value = next;
    //this.onChange(next);
    this.onTouched();
    this.valueChange.emit(next);
  }
}